import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import FileSaver from 'file-saver';

import {withIsOpenState} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import CustomScrollbar, {CustomScrollbarTrackVisibility} from '../../../lib/custom-scrollbar/custom-scrollbar';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import retardUpdate from '../../../lib/react/update-retarder';
import {OEGroupControl, OEControl} from '../../elements/controls/oe-controls';
import OEIcon from '../../elements/oe-icon';
import OEButton, {OEIconButton} from '../../elements/controls/oe-button';
import OEWidgetHeader from '../../elements/oe-widget-header';
import OEPopover from '../../views/oe-popover';
import {OEPopoverMenuButton} from '../../views/oe-popover-menu';
import {OEPresetType, OEPresetSetType, OEPresetResult, OEPresetTypeHelper} from './oe-preset-model';
import OEPresetTableCell from './oe-preset-table-cell';

export class OEPresetController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.presetType = OEPresetTypeHelper.presetTypeToArray(this.props.presetType);
        this.presetSetType = this.props.presetSetType;
        this.presetSetData = [];

        this.menuEntries = this.addMenuEntries();

        this.state = {
            uiEnabled:              false,
            presetSetType:          this.presetSetType,
            presetSetData:          [],
            controllerUIEnabled: {
                note:               false,
                camera:             false,
                cut:                false,
                color:              false,
                components:         false
            },
            btns: {
                dump:               false,
                save:               false,
                load:               false,
                add:                false
            },
            strings: {
                setTypeStatic:      'static',
                setTypeModelState:  'state',
            },
            menuEntries:            clone(this.menuEntries)
        };

        this.onPresetAdded = this.onPresetAdded.bind(this);
        this.onPresetRemoved = this.onPresetRemoved.bind(this);
        this.onPresetChanged = this.onPresetChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onFileLoadInputRef = this.onFileLoadInputRef.bind(this);
        this.onAddMenuRef = this.onAddMenuRef.bind(this);

        this.renderHeaderCenterBar = this.renderHeaderCenterBar.bind(this);

        this.onPresetSetTypeBtnPressed = this.onPresetSetTypeBtnPressed.bind(this);
        this.onPresetSelectionChange = this.onPresetSelectionChange.bind(this);
        this.onPresetDumpBtnPressed = this.onPresetDumpBtnPressed.bind(this);
        this.onPresetNameChanged = this.onPresetNameChanged.bind(this);
        this.onPresetApplyBtnPressed = this.onPresetApplyBtnPressed.bind(this);
        this.checkIfAdded = this.checkIfAdded.bind(this);
        this.onAddBtnPressed = this.onAddBtnPressed.bind(this);
        this.onAddMenuSelection = this.onAddMenuSelection.bind(this);
        this.onLoadBtnPressed = this.onLoadBtnPressed.bind(this);
        this.onSaveBtnPressed = this.onSaveBtnPressed.bind(this);
        this.onLoadInputResult = this.onLoadInputResult.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let needsPresetSetUpdate = false;
        let needsAddMenuEntriesUpdate = false;
        
        if(nextProps.presetSetType !== this.props.presetSetType)    {
            this.presetSetType = nextProps.presetSetType;
            this.setState({presetSetType: this.presetSetType});
            needsPresetSetUpdate = true;
        }

        if(!OEToolbox.shallowEqual(nextProps.presetType, this.props.presetType, true)) {
            let presetType = OEPresetTypeHelper.presetTypeToArray(nextProps.presetType);

            if(!OEToolbox.shallowEqual(presetType, this.presetType, true)) {
                this.presetType = presetType;
                needsPresetSetUpdate = true;
                needsAddMenuEntriesUpdate = true;
            }
        }

        if(needsPresetSetUpdate)    {
            this.updatePresetSet(nextProps);
        }

        if(needsAddMenuEntriesUpdate || nextProps.refId !== this.props.refId) {
            this.updateAddMenuEntries(nextProps);
        }
        
        if(nextProps.refId !== this.props.refId || nextProps.onPresetApplyBtnPressed !== this.props.onPresetApplyBtnPressed || nextProps.applyPresetEnabled !== this.props.applyPresetEnabled) {
            this.updateUIState(nextProps);
        }
    }

    onConnect() {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presetAdded, this.onPresetAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presetRemoved, this.onPresetRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presetChanged, this.onPresetChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease() {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presetAdded, this.onPresetAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presetRemoved, this.onPresetRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presetChanged, this.onPresetChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    setPresetSetType(setType) {
        if(this.presetSetType === setType)  return;
        this.presetSetType = setType;
        this.setState({presetSetType: this.presetSetType});
        this.onPresetSetTypeChanged();
    }

    onPresetSetTypeChanged()    {
        this.updatePresetSet();
    }

    addMenuEntries(props) {
        props = props || this.props;

        if(!this.presetType.length) return [];

        let addableTypes = typeof(props.refId) === 'number' ? 
                            [OEPresetType.note, OEPresetType.camera, OEPresetType.cut, OEPresetType.color, OEPresetType.components] :
                            [OEPresetType.camera, OEPresetType.cut, OEPresetType.color, OEPresetType.components];

        let types = this.presetType.includes(OEPresetType.any) ? addableTypes : addableTypes.filter(type => this.presetType.includes(type));

        return types.map(type => {
            let typeAsString = OEPresetType.toString(type);
            return {id: type, icon: OEIconCodes.preset.type[typeAsString]};
        });
    }

    updateAddMenuEntries(props)  {
        this.menuEntries = this.addMenuEntries(props);
        this.setState({menuEntries: clone(this.menuEntries)});
    }

    updatePresetSet() {
        if(!this.oe.isReady())  return;

        let coreTypes = OEPresetTypeHelper.presetTypeToCore(this.presetType);

        let presetSetData = coreTypes ? this.oe.sharedInterface.getUIControllerPreset().getPresetSetData(coreTypes, this.presetSetType) : [];
        this.presetSetData = presetSetData.map(data => Object.assign({selected: false}, data, {type: OEPresetTypeHelper.presetTypeFromCore(data.type), added: false}));

        this.setState({presetSetData: clone(this.presetSetData)});
        this.updateBtnStates();
    }

    updateBtnStates() {
        let uiEnabled = this.oe.sharedInterface.getUIControllerPreset().getUIEnabled();
        let hasSelection = this.presetSetData.findIndex(preset => preset.selected === true) >= 0 ? true : false;
        this.setState({
            btns: {
                save:                   uiEnabled && this.presetSetData.length > 0,
                load:                   uiEnabled && this.presetType.filter(type => type != OEPresetType.unknown).length > 0,
                add:                    uiEnabled && this.menuEntries.length > 0
            }
        });
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;
        this.setState({strings: {
            setTypeStatic:          si.getLocalizedStringEnc('preset_view_set_type_static'),
            setTypeModelState:      si.getLocalizedStringEnc('preset_view_set_type_model_state')
        }});
    }

    updateUIState(props) {
        if(!this.oe.isReady())  return;
        
        props = props || this.props;
        let uiEnabled = this.oe.sharedInterface.getUIControllerPreset().getUIEnabled();

        let applyEnabled = props.onPresetApplyBtnPressed && (typeof(props.applyPresetEnabled) !== 'boolean' || props.applyPresetEnabled);

        let controllerUIEnabled = {
            note:                   (this.oe.sharedInterface.getUIControllerNote().getUIEnabled() && typeof(props.refId) === 'number') || applyEnabled,
            camera:                 true,
            cut:                    this.oe.sharedInterface.getUIControllerCut().getUIEnabled() || applyEnabled,
            color:                  this.oe.sharedInterface.getUIControllerComponent().getUIEnabled() || applyEnabled,
            components:             this.oe.sharedInterface.getUIControllerComponent().getUIEnabled() || applyEnabled
        };

        this.setState({uiEnabled: uiEnabled, controllerUIEnabled: controllerUIEnabled});

        this.updateBtnStates();
    }

    updateState(released) {
        if(!this.oe.isReady() || released === true) {
            this.presetSetData = [];
            this.setState({
                uiEnabled:          false,
                presetSetData:      [],
                controllerUIEnabled: {
                    note:           false,
                    camera:         false,
                    cut:            false,
                    color:          false,
                    components:     false
                },
                btns: {
                    dump:           false,
                    save:           false,
                    load:           false,
                    add:            false
                }
            });
            if(this.addMenuRef) this.addMenuRef.close();
            return;
        }

        retardUpdate(this, () => {
            this.updatePresetSet();
            this.updateUIState();
        });
    }

    onUIControllerStateChanged(message, userInfo) {
        if(userInfo.type === this.oe.Module.UIControllerType.preset || userInfo.type === this.oe.Module.UIControllerType.note || userInfo.type === this.oe.Module.UIControllerType.cut || userInfo.type === this.oe.Module.UIControllerType.component) {
            this.updateUIState();
        }
    }

    onPresetAdded(message, userInfo) {
        if(!(this.presetSetType & userInfo.setType)) return;
        let type = OEPresetTypeHelper.presetTypeFromCore(userInfo.data.type);
        if(!this.presetType.includes(OEPresetType.any) && !this.presetType.includes(type))  return;
        this.presetSetData.push(Object.assign({selected: false}, userInfo.data, {type: OEPresetTypeHelper.presetTypeFromCore(userInfo.data.type), added: this.adding}));
        this.setState({presetSetData: clone(this.presetSetData)});
        this.updateBtnStates();
    }

    onPresetRemoved(message, userInfo) {
        if(!(this.presetSetType & userInfo.setType)) return;
        let index = this.presetSetData.findIndex(preset => preset.id === userInfo.ID);
        if(index < 0)   return;
        this.presetSetData.splice(index, 1);
        this.setState({presetSetData: clone(this.presetSetData)});
        this.updateBtnStates();
    }

    onPresetChanged(message, userInfo) {
        let index = this.presetSetData.findIndex(preset => preset.id === userInfo.data.id);
        if(index < 0)   return;
        this.presetSetData[index].name = userInfo.data.name;
        this.setState({presetSetData: clone(this.presetSetData)});
    }

    onFileLoadInputRef(ref)    {
        this.fileLoadInput = ref;
    }

    onAddMenuRef(ref)   {
        this.addMenuRef = ref;
    }

    renderHeaderCenterBar(props)    {
        return (
            <React.Fragment>

                <OEIconButton
                    className="transparent-btn save-btn"
                    icon={OEIconCodes.preset.save}
                    onPressed={this.onSaveBtnPressed}
                    disabled={!props.btns.save}
                />

                <OEIconButton
                    className="transparent-btn load-btn"
                    icon={OEIconCodes.preset.load}
                    onPressed={this.onLoadBtnPressed}
                    disabled={!props.btns.load}
                />

                <OEPopoverMenuButton
                    ref={this.onAddMenuRef}
                    className="transparent-btn add-btn"
                    placement="top"
                    boundariesElement={props.boundariesElement}
                    hideArrow={false}
                    entries={props.menuEntries}
                    onChange={this.onAddMenuSelection}
                    disabled={!props.btns.add}
                    onPressed={this.onAddBtnPressed}
                >
                    <OEIcon code={OEIconCodes.preset.add}/>
                </OEPopoverMenuButton>

            </React.Fragment>
        );
    }

    renderSetTypeControl()  {
        if(!this.props.presetSetTypeChangeable) return null;

        return (
            <OEControl className="align-right">

                <OEButton
                    disabled={!(this.state.uiEnabled)}
                    activated={this.state.presetSetType === OEPresetSetType.static}
                    className="transparent-btn option left"
                    onPressed={this.onPresetSetTypeBtnPressed}
                    setType={OEPresetSetType.static}
                >
                    <span>{this.state.strings.setTypeStatic}</span>
                </OEButton>

                <OEButton
                    disabled={!(this.state.uiEnabled)}
                    activated={this.state.presetSetType === OEPresetSetType.modelState}
                    className="transparent-btn option right"
                    onPressed={this.onPresetSetTypeBtnPressed}
                    setType={OEPresetSetType.modelState}
                >
                    <span>{this.state.strings.setTypeModelState}</span>
                </OEButton>

            </OEControl>
        );
    }

    renderControls()  {
        let setTypeControl = this.renderSetTypeControl();
        if(!setTypeControl) return null;

        return (
            <OEGroupControl className="compact controls">
                {setTypeControl}
            </OEGroupControl>
        );
    }
    
    render() {
        let showCellIcon = this.props.showTypeIconAllways || (Array.isArray(this.props.presetType) && this.props.presetType.length > 1);

        let cells = this.state.presetSetData.map((preset, i) =>
            <OEPresetTableCell
                key={preset.id}
                id={preset.id}
                name={preset.name}
                type={preset.type}
                uiEnabled={this.state.uiEnabled}
                controllerUIEnabled={this.state.controllerUIEnabled}
                selected={preset.selected}
                showSeparator={i + 1 < this.state.presetSetData.length}
                showIcon={showCellIcon}
                onSelectionChange={this.onPresetSelectionChange}
                onDumpBtnPressed={this.onPresetDumpBtnPressed}
                onNameChanged={this.onPresetNameChanged}
                onApplyBtnPressed={this.onPresetApplyBtnPressed}
                checkIfAdded={this.checkIfAdded}
             />
        );

        return  (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div className={'preset-controller ' + this.props.className}>

                    <input id="presetFileLoad"
                        type="file"
                        accept=".xpres"
                        ref={this.onFileLoadInputRef}
                        style={{display: 'none'}}
                        onChange={this.onLoadInputResult}
                    />

                    <OEWidgetHeader
                        moduleId={this.props.moduleId}
                        buttonClassName="transparent-btn"
                        icon={this.props.icon}
                        title={this.props.title}
                        titleId={this.props.titleId}
                        headerSeparator={this.props.headerSeparator}
                        centerBar={this.renderHeaderCenterBar}
                        onToggle={this.props.onToggle}
                        boundariesElement={this.props.boundariesElement}
                        btns={this.state.btns}
                        menuEntries={this.state.menuEntries}
                    />

                    {this.renderControls()}

                    {this.props.children}

                    <div className="preset-list">
                        <CustomScrollbar
                            horizontalTrackVisiblity={CustomScrollbarTrackVisibility.none}
                            verticalTrackVisiblity={CustomScrollbarTrackVisibility.always}
                        >
                            {cells}
                        </CustomScrollbar>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    onPresetSetTypeBtnPressed(e, sender) {
        this.setPresetSetType(sender.props.setType);
    }

    onPresetSelectionChange(id) {
        let index = this.presetSetData.findIndex(preset => preset.id === id);
        if(index < 0 || index >= this.presetSetData.length)   return;
        this.presetSetData[index].selected = !this.presetSetData[index].selected;
        this.setState({presetSetData: clone(this.presetSetData)});
        this.updateBtnStates();
    }

    onPresetDumpBtnPressed(id) {
        if(!this.oe.isReady())  return;
        this.oe.sharedInterface.getUIControllerPreset().removePreset(id);
    }

    onPresetNameChanged(id, text) {
        if(!this.oe.isReady())  return;
        this.oe.sharedInterface.getUIControllerPreset().setPresetName(id, OEToolbox.encode_utf8(text));
    }

    onPresetApplyBtnPressed(id) {
        if(!this.props.onPresetApplyBtnPressed) {
            if(this.oe.isReady())    this.oe.sharedInterface.getUIControllerPreset().applyPreset(id, this.props.refId);
        } else {
            this.props.onPresetApplyBtnPressed(this, id);
        }
    }

    checkIfAdded(id) {
        let index = this.presetSetData.findIndex(preset => preset.id === id);
        if(index < 0)   return false;
        let added = this.presetSetData[index].added;
        this.presetSetData[index].added = false;
        return added;
    }

    onAddBtnPressed() {
        if(this.addMenuRef.isOpen())    {
            this.addMenuRef.close();
            return;
        }
        if(!this.oe.isReady() || this.state.menuEntries.length === 0)  return;
        if(this.state.menuEntries.length > 1)    {
            if(this.addMenuRef) this.addMenuRef.open();
        } else {
            let presetType = OEPresetTypeHelper.presetTypeToCore(this.state.menuEntries[0].id);
            this.adding = true;
            this.oe.sharedInterface.getUIControllerPreset().addPreset('', presetType, this.props.refId, this.presetSetType);
            this.adding = false;
        }
    }

    onAddMenuSelection(id)    {
        if(this.addMenuRef) this.addMenuRef.close();
        if(!this.oe.isReady()) return;
        let presetType = OEPresetTypeHelper.presetTypeToCore(id);
        this.adding = true;
        this.oe.sharedInterface.getUIControllerPreset().addPreset('', presetType, this.props.refId, this.presetSetType);
        this.adding = false;
    }

    onLoadBtnPressed()  {
        if(!this.fileLoadInput) return;
        this.fileLoadInput.value = null; // empties the file list so that onLoadInputResult gets called when loading the same file multiple times successively
        this.fileLoadInput.click();
    }
    
    onSaveBtnPressed() {
        this.props.appComponent.showWaitingController();
        this.savePreset(function(result)    {
            this.props.appComponent.hideWaitingController();
            if(result != OEPresetResult.ok)   console.log('Saving preset failed with error - ' + OEPresetResult.toString(result));
        }.bind(this));
    }

    savePreset(callback) {
        let presetType = OEPresetTypeHelper.presetTypeToCore(this.presetType);

        if(!this.oe.isReady() || !presetType) {
            callback(!presetType ? OEPresetResult.unexpected : OEPresetResult.ok);
            return;
        }

        let presetController = this.oe.sharedInterface.getUIControllerPreset();
        let result = presetController.save(presetType, this.presetSetType);

        if(result.result.value != OEPresetResult.ok) {
            callback(result.result);
            return;
        }

        let types = this.presetType;
        let filename = 'presets.xpres';
        if(types.length == 1 && types[0] !== OEPresetType.any) {
            let prefix = '';
            switch(types[0]) {
                case OEPresetType.unknown:      prefix = 'unknown'; break;
                case OEPresetType.any:          prefix = 'any'; break;
                case OEPresetType.dummy:        prefix = 'dummy'; break;
                case OEPresetType.note:         prefix = 'note'; break;
                case OEPresetType.camera:       prefix = 'camera'; break;
                case OEPresetType.cut:          prefix = 'cut'; break;
                case OEPresetType.color:        prefix = 'color'; break;
                case OEPresetType.components:   prefix = 'components'; break;
                default: break;
            }
            filename = prefix + '-presets.xpres';
        }

        FileSaver.saveAs(new Blob([new Uint8Array(result.buffer)]), filename);
        callback(OEPresetResult.ok);
    }

    loadPreset(files, callback) {
        let presetType = OEPresetTypeHelper.presetTypeToCore(this.presetType);

        if(!presetType) {
            callback(OEPresetResult.unexpected);
            return;
        }

        let allFileProgress = {i: 0, num: files.length, aborted: false};

        let onLoadFunction = function(event) {
            if(allFileProgress.aborted || event.target.readyState != FileReader.DONE) return;

            if(!this.oe.isReady()) {
                allFileProgress.aborted = true;
                callback(OEPresetResult.ok);
                return;
            }

            let arrayBuffer = event.target.result;
            let result = this.oe.sharedInterface.getUIControllerPreset().loadFromBuffer(arrayBuffer, presetType, this.presetSetType).value;

            if(result != OEPresetResult.ok && result != OEPresetResult.noPresetsFound) {
                allFileProgress.aborted = true;
                callback(result);
                return;
            }

            allFileProgress.i = allFileProgress.i + 1;
            if(allFileProgress.i == allFileProgress.num) callback(OEPresetResult.ok);

        }.bind(this);

        for(let i = 0; i < files.length; ++i)  {
            if(allFileProgress.aborted) break;
            let reader = new FileReader();
            reader.onload = onLoadFunction;
            reader.readAsArrayBuffer(files[i]);
        }
    }

    onLoadInputResult(event) {
        event.stopPropagation();
        event.preventDefault();
        if(event.target.files.length == 0) return;
        this.props.appComponent.showWaitingController();

        this.loadPreset(event.target.files, result => {
            this.props.appComponent.hideWaitingController();
            if(result != OEPresetResult.ok) console.log('Loading presets failed with error - ' + OEPresetResult.toString(result));
        });
    }
}

OEPresetController.defaultProps = {
    moduleId:                   '',
    className:                  '',
    titleId:                    'preset_view',
    headerSeparator:            true,
    presetSetType:              OEPresetSetType.static,
    presetSetTypeChangeable:    false,
    showTypeIconAllways:        false
};

OEPresetController.propTypes = {
    moduleId:                   PropTypes.string,
    className:                  PropTypes.string,
    icon:                       PropTypes.string,
    title:                      PropTypes.string,
    titleId:                    PropTypes.string,
    headerSeparator:            PropTypes.bool,
    presetType:                 OEPresetTypeHelper.presetTypeNumberArrayDecl,
    presetSetType:              PropTypes.oneOf([OEPresetSetType.static, OEPresetSetType.modelState]),
    presetSetTypeChangeable:    PropTypes.bool,
    showTypeIconAllways:        PropTypes.bool,
    refId:                      PropTypes.number,
    applyPresetEnabled:         PropTypes.bool,
    onPresetApplyBtnPressed:    PropTypes.func,
    onToggle:                   PropTypes.func
};

//
export const OEPresetPopoverController = OEPopover.coat(OEPresetController, {
    noHeader:                   true,
}, {
    placement:                  'right',
    buttonClassName:            'transparent-btn',
    controllerClassName:        ''
}, {
    controllerClassName:        PropTypes.string
});

//
export default withIsOpenState(OEPresetPopoverController);